import { Injectable } from '@angular/core';
import { HttpBaseService } from './http-base.service';
import { lastValueFrom } from 'rxjs';
import { IJobs } from '../../modules/client/dashboard/job-board/job-board.interface';

@Injectable({
  providedIn: 'root'
})
export class JobBoardService {

    constructor(private http: HttpBaseService) { }

    getJobBoardListings(searchFilters: any): Promise<any> {
      return lastValueFrom(this.http.post(`jobs/get`, searchFilters));
    }
    
    createJob(jobData: IJobs): Promise<any> {
      return lastValueFrom(this.http.post(`jobs`, jobData));
    }
    
    updateJob(jobData: IJobs): Promise<any> {
      return lastValueFrom(this.http.put(`jobs`, jobData));
    }
    
    getJobDetail(jobId: string): Promise<any> {
      return lastValueFrom(this.http.get(`jobs/${jobId}`));
    }
    
    getAllApplicants(payload: any): Promise<any> {
      let url = 'jobs/candidates?';
      if (payload.jobId) {
        url += `jobId=${payload.jobId}&`;
      }
      url += `limit=${payload.limit}&offset=${payload.offset}&search=${payload.search}&searchOn=${payload.searchOn ? payload.searchOn : 'all'}`;
      return lastValueFrom(this.http.get(url));
    }

    submitJobApplication(payload: { appliedCandidateId: string; appliedJobId: string; jobAppliedDate: string }): Promise<any> {
        return lastValueFrom(this.http.post('jobs/new-job-application', payload));
    }

    getAppliedJobApplications(params: any): Promise<any> {
        return lastValueFrom(this.http.get('jobs/applied-job-applications', { params }));
    }

    updateCandidate(payload: any): Promise<any> {
        return lastValueFrom(this.http.put('jobs/candidate', payload));
    }
}